/**
 * 模块: AI 分析操作列
 * 职责: 定义关键词表格中的 AI 分析按钮列
 * 限制: <280行
 */

import React from 'react';
import { Button, Tooltip } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';

/**
 * AI 分析操作列
 * 提供单个关键词的 AI 分析入口
 */
export const createAIActionColumns = (
  onAnalyze?: (record: any) => void
): ColumnsType<any> => {
  if (!onAnalyze) {
    return [];
  }

  return [
    {
      title: '智能分析',
      key: 'ai_action',
      fixed: 'right' as const,
      width: 100,
      render: (_: any, record: any) => (
        <Tooltip title="AI 智能分析该关键词">
          <Button
            type="primary"
            size="small"
            icon={<RobotOutlined />}
            onClick={() => onAnalyze(record)}
          >
            智能分析
          </Button>
        </Tooltip>
      ),
    },
  ];
};

